import { Dialog, DialogContent } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { ReactNode, useEffect } from 'react';

import { CloseableDialogTitle } from '../../molecules/CloseableDialogTitle/CloseableDialogTitle';
import { Link } from '../Link';

export const Modal: React.FC<ModalProps> = props => {
  const { title, children, trigger, closeable, fullscreen } = props;
  const theme = useTheme();
  const fullScreen = fullscreen ?? useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = React.useState(props.open ?? false);

  const handleClickOpen = () => {
    if (props.handleOpen !== undefined && props.open === undefined) {
      props.handleOpen();
      return;
    }
    setOpen(true);
  };

  useEffect(() => {
    setOpen(props.open ?? false);
  }, [props.open]);

  const handleClose = () => {
    if (!closeable) {
      return;
    }
    if (props.handleClose) {
      props.handleClose();
      return;
    }
    setOpen(false);
  };

  return (
    <>
      {props.includesTrigger && <div onClick={handleClickOpen}>{trigger}</div>}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen={fullScreen}
      >
        {closeable && (
          <CloseableDialogTitle id="alert-dialog-title" onClose={handleClose}>
            {title}
          </CloseableDialogTitle>
        )}
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </>
  );
};

Modal.defaultProps = {
  linkText: 'Weitere Informationen',
  trigger: <Link text="Weitere Informationen" />,
  includesTrigger: false,
  closeable: true
};

export interface ModalProps {
  includesTrigger?: boolean;
  trigger?: ReactNode;
  children: ReactNode;
  title?: string;
  linkText?: string;
  cta?: boolean;
  fullscreen?: boolean;
  open?: boolean;
  closeable?: boolean;
  handleClose?: () => void;
  handleOpen?: () => void;
}
